/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import React, {createRef} from "react";
import autobind from "autobind-decorator";
import {Button} from "react-bootstrap";
import {Glyphicon} from "../../../Components/Common/GlyphIcon";

export class ImageUploadFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.inputField = createRef();
	}

	@autobind
	displayDialog() {
		const {inputField} = this;
		inputField?.current?.click?.();
	}

	@autobind
	onFileSelect(e) {
		const {OnUpdate} = this.props;
		const reader = new FileReader();
		reader.readAsDataURL(e.target.files[0]);
		reader.onload = () => {
			OnUpdate(reader.result);
		};
	}

	@autobind
	deleteCurrent() {
		this.inputField.current.value = null;
		this.props.OnUpdate(null);
	}

	@autobind
	_render() {
		const {Value} = this.props;
		const inputField = this.inputField;
		return <div className="sb-single-line-with-button-field-editor">
			<div className="pndlm-image-editor-preview">
				{Value ? <img src={Value} alt=""/> : null}
			</div>

			<Button
				className="pndlm-image-upload-button pndlm-button-grey"
				onClick={this.displayDialog}
			>
				Upload
			</Button>

			<input
				style={{display: "none"}}
				ref={this.inputField}
				type="file"
				onChange={this.onFileSelect}
				onClick={() => {
					inputField.current.value = null; /* this ensures onChange is triggered for the same file */
				}}
				multiple={false}
			/>

			<a className="pndlm-image-delete-reset-button" onClick={this.deleteCurrent}>
				<Glyphicon glyph="remove-sign"/>
				Delete
			</a>
		</div>;
	}
}